import { IdentifierFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { Identifier } from "src/types/identifier";

export const mapIdentifier = (fragment: IdentifierFragmentFragment): Identifier => ({
  value: fragment.value,
  id: fragment.id,
  identifierType: {
    code: fragment.identifierType.code,
    name: fragment.identifierType.name,
  },
  schemaIdentifier: {
    code: fragment.schemaIdentifier.code,
    name: fragment.schemaIdentifier.name,
  },
});
